export type MunilyCheckboxListSelectionMode = 'single' | 'multiple';

export type MunilyCheckboxListLayout = 'rows' | 'columns';

export type MunilyCheckboxListCheckboxType = 'bullet' | 'check_box' | 'check_circle';

export type MunilyCheckboxListOption<TValue extends string = string> = {
  value: TValue;
  /** i18n key or plain text (same behavior as `app-common-checkbox.labelKey`). */
  labelKey: string;
  /** Parámetros para la clave i18n (mismo contrato que `app-common-checkbox.labelParams`). */
  labelParams?: Record<string, string | number>;
  disabled?: boolean;
};

export const MUNILY_CHECKBOX_LIST_DEFAULTS = {
  titleKey: '',
  options: [] as MunilyCheckboxListOption<string>[],
  checkboxType: 'bullet' as MunilyCheckboxListCheckboxType,
  selectionMode: 'single' as MunilyCheckboxListSelectionMode,
  layout: 'rows' as MunilyCheckboxListLayout,
  columns: 2,
  disabled: false,
};

